import React from 'react';

import Upload from './Upload';
import Import from './Import';

import Dialog from './Dialog';
import { downloadFile } from 'utils';
import { srtToUrl, subToSrt } from 'utils/subtitle';

import {
  FiUpload,
  FiDownload,
  FiRotateCcw,
  FiTrash2,
  FiSave,
  FiArrowLeft,
  FiDownloadCloud,
} from 'react-icons/fi';

import {
  Header,
  LeftHeader as Left,
  RightHeader as Right,
  Logo,
  Menu,
} from './styles';
import { useNavigate } from 'react-router-dom';

export default function(props) {
  const navigate = useNavigate();
  return (
    <Header>
      <Left>
        <Logo onClick={() => navigate(-1)}>
          <FiArrowLeft />
        </Logo>
        <Menu onClick={() => props.setOption({ uploadDialog: true })}>
          <FiUpload />
          <p>CARREGAR</p>
        </Menu>
        <Menu onClick={() => props.setOption({ importDialog: true })}>
          <FiDownloadCloud />
          <p>IMPORTAR LEGENDA</p>
        </Menu>
        <Menu
          onClick={() =>
            downloadFile({
              url: srtToUrl(subToSrt(props.subtitles)),
              name: `${Date.now()}.srt`,
            })
          }
          // onClick={() =>
          //   downloadFile(
          //     vttToUrl(subToVtt(props.subtitles)),
          //     `${Date.now()}.vtt`,
          //   )
          // }
        >
          <FiDownload />
          <p>EXPORTAR LEGENDA</p>
        </Menu>
        <Menu onClick={() => props.undoSubtitles()}>
          <FiRotateCcw />
          <p>UNDO</p>
        </Menu>
        <Menu
          onClick={() => {
            if (
              window.confirm('Tem certeza que deseja apagar todas as legendas?')
            ) {
              props.cleanSubtitles();
            }
          }}
        >
          <FiTrash2 />
          <p>APAGAR LEGENDA</p>
        </Menu>
      </Left>
      <Right>
        <Menu
          reverse
          disabled={props.loadingSubmit}
          onClick={() => props.saveSubtitle(true)}
        >
          <FiSave />
          {props.loadingSubmit ? <p>SALVANDO ...</p> : <p>SALVAR LEGENDA</p>}
        </Menu>
        <Menu color="success" reverse onClick={() => props.finishSubtitle()}>
          <FiSave />
          {props.loadingFinish ? <p>SALVANDO ...</p> : <p>FINALIZAR LEGENDA</p>}
        </Menu>
      </Right>
      {props.options.uploadDialog ? (
        <Dialog
          title="CARREGAR ARQUIVO"
          onClose={() => props.setOption({ uploadDialog: false })}
        >
          <Upload {...props} />
        </Dialog>
      ) : null}

      {props.options.importDialog ? (
        <Dialog
          title="IMPORTAR LEGENDA"
          onClose={() => props.setOption({ importDialog: false })}
        >
          <Import {...props} />
        </Dialog>
      ) : null}
    </Header>
  );
}
